import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, catchError, of, throwError } from 'rxjs';

import { isPlatformServer } from '@angular/common';
import { ErrorService } from '../services/error.service';
import { ENVIRONMENT } from '@shared/tokens';
import { OMIT_HTTP_ERROR_CODES_ACTION } from '@shared/constants/OMIT_HTTP_ERROR_CODES_HTTP_CONTEXT';

@Injectable()
export class APIInterceptor implements HttpInterceptor {
  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    @Inject(ENVIRONMENT) private environment: any,
    private _errorService: ErrorService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    //Żeby nie strzelać do backendu podczas prerenderowania;
    if (isPlatformServer(this.platformId)) {
      console.log('Skipping request due to SSR');
      return of();
    }

    if (req.url.startsWith('http')) {
      return next.handle(req).pipe(
        catchError((err: HttpErrorResponse) => {
          this._errorService.showError(err);
          console.error(err);
          return throwError(() => err);
        })
      );
    }

    const headers: any = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    };

    if (localStorage.getItem('TEST_MODE') == 'true') {
      headers['TEST-MODE'] = 'true';
    }

    const apiReq = req.clone({
      url: `${this.environment.API_URL}/${req.url}`,
      setHeaders: headers,
      withCredentials: true,
    });
    return next.handle(apiReq).pipe(
      catchError((err: HttpErrorResponse) => {
        const omitHttpErrorCodes = req.context.get(
          OMIT_HTTP_ERROR_CODES_ACTION
        );
        if (
          !Array.isArray(omitHttpErrorCodes) ||
          !omitHttpErrorCodes.includes(err.status)
        ) {
          this._errorService.showError(err);
        }
        console.error(err);
        return throwError(() => err);
      })
    );
  }
}
